import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { DATE_FORMAT } from 'src/app/core/constants/global.constants';
import { TOASTER_MESSAGE } from 'src/app/core/constants/toaster-messages.contants';
import { HelperService } from '../../../services/helper.service';
import { ExportFileService } from '../../../services/export-file.service';

@Component({
  selector: 'app-export-file',
  templateUrl: './export-file.component.html',
  styleUrls: ['./export-file.component.css']
})
export class ExportFileComponent implements OnInit {

  @Input() parentPageName: string;
  @Input() headerJson: any[] = [];
  list: any[] = [];

  @Input('list')
  set setList(value: any[]) {
    if (value) {
      this.list = value;
    }
  }

 

  constructor(
    private exportFileService: ExportFileService,
    private helperService: HelperService,
    private toasterService: ToastrService
  ) { }

  ngOnInit() {
  }

  exportFile(fileType: string): void {
    let customizedList: any = [];
    const fileName = this.parentPageName;
    const jsonKeys = _.map(this.headerJson, 'field');
    const displayNames = _.map(this.headerJson, 'displayName');
   // const dateFileds = _.map(this.headerJson.filter(ele => ele.date), 'field');
    if (jsonKeys.length) {
      const exportWith = _.zipWith(jsonKeys, displayNames, (key, value) => ({ key, value }));
      let newModel = {};
      let listData: any[] = _.cloneDeep(this.list);
      newModel = _.map(listData, _.partialRight(_.pick, jsonKeys));
      customizedList = newModel;
      this.exportFileService.exportAsFile(customizedList, exportWith, fileName, fileType);
    } else {
      this.toasterService.warning(TOASTER_MESSAGE.DOWNLOAD_WARNING);
    }
  }

  
}
